import {cpServiceV2Get} from 'api';
import {camelizeKeys} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';
import {
    Experiment,
    RawExperimentsResponse,
} from 'api/experiments/experiments.types';

/**
 * Formats the response from the experiments API.
 */
const formatResponse = (response: RawExperimentsResponse): Experiment[] => {
    const formattedResponse: Experiment[] = camelizeKeys(response.results);

    return formattedResponse;
};

/**
 * Gets the experiments
 */
const getExperiments = async (): Promise<Experiment[]> => {
    try {
        const response =
            await cpServiceV2Get<RawExperimentsResponse>(`experiments`);

        const formattedResponse = formatResponse(response.data.data);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getExperiments;
